var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AssetsLoader } from '../../../../lib/classes';
import { Animation } from '../../../../lib/classes/animation';
import { roundRect } from '../../../../lib/utils';
import clapperboard from './clapperboard.svg';
var TimerEffect2 = /** @class */ (function (_super) {
    __extends(TimerEffect2, _super);
    function TimerEffect2(props) {
        return _super.call(this, props) || this;
    }
    TimerEffect2.prototype.upd = function (dt) {
        if (this.props.speed) {
            dt *= this.props.speed;
        }
        this.time += dt;
    };
    TimerEffect2.prototype.isDone = function () {
        return this.props.time < this.time;
    };
    TimerEffect2.prototype.draw = function (scene) {
        if (this.props.mask) {
            scene.fillAll(this.props.mask);
        }
        var w = 90;
        var h = 50;
        var x = (scene.width - w) / 2;
        var y = (scene.height - h) - 20;
        roundRect(scene, x, y, w, h, 10, 'rgba(0,0,0,0.65)');
        var time = Math.max(0, Math.ceil((this.props.time - this.time) / 1000));
        // Текст
        scene.font(30);
        var text = String(time);
        var tx = x + w / 2 - scene.textWidth(text) / 2 + 20;
        var ty = y + h / 2 + 10;
        scene.fillStyle('#fff');
        scene.fillText(text, tx, ty);
        // Картинка
        var img = AssetsLoader.getAsset(clapperboard);
        if (!img)
            return;
        var iw = 30;
        var ih = iw * (img.height / img.width);
        scene.drawImage(img, 0, 0, img.width, img.height, x + 10, y + 10, iw, ih);
    };
    return TimerEffect2;
}(Animation));
export { TimerEffect2 };
